import React from 'react'

const ErrorContext = React.createContext([])

export const ErrorProvider = ({error,children}) => {
    return <ErrorContext.Provider value={error}>{children}</ErrorContext.Provider>
}
export const ErrorConsumer = ErrorContext.Consumer
export default ErrorContext